module.exports = __webpack_public_path__ + "cc12726d08f8535d29e07c30907b04b1.svg";